module.exports = __webpack_public_path__ + "static/media/exchangeIco_Selected.ab665766.svg";